import { defineMessages } from 'react-intl'

export const textAreaMessages = defineMessages({
  placeholder: {
    id: 'textArea.placeholder',
    description: 'Default placeholder for TextArea input',
    defaultMessage: 'Text',
  },
})
